export var ViewerSetupEventType;
(function (ViewerSetupEventType) {
    ViewerSetupEventType["readyForPort"] = "ready-for-port";
})(ViewerSetupEventType || (ViewerSetupEventType = {}));
export var ViewerEventType;
(function (ViewerEventType) {
    ViewerEventType["ready"] = "ready";
    ViewerEventType["success"] = "success";
    ViewerEventType["error"] = "error";
})(ViewerEventType || (ViewerEventType = {}));
//# sourceMappingURL=viewer-events.js.map